class SizeGuideModal extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    // Escape product stacking contexts so overlay sits above the header
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }

    this.overlay = this.querySelector('[data-size-guide-overlay]');
    this.dialog = this.querySelector('[data-size-guide-dialog]');

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onHostClick = this.onHostClick.bind(this);

    this.addEventListener('click', this.onHostClick);

    if (this.dialog) {
      this.dialog.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }

    this.querySelectorAll('[data-size-guide-close]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      });
    });

    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeyDown);
  }

  onHostClick(event) {
    // Click on scrim / empty host area closes; clicks inside dialog are stopped above
    if (
      event.target === this ||
      event.target === this.overlay ||
      (event.target && event.target.hasAttribute && event.target.hasAttribute('data-size-guide-overlay'))
    ) {
      this.close();
    }
  }

  onDocumentClick(event) {
    const trigger = event.target.closest('[data-size-guide-open]');
    if (!trigger) return;

    const targetId = trigger.getAttribute('data-size-guide-open');
    if (targetId !== this.id) return;

    event.preventDefault();
    this.open(trigger);
  }

  onKeyDown(event) {
    if (event.key === 'Escape') this.close();
  }

  open(trigger) {
    this.trigger = trigger || null;
    this.classList.add('is-open');
    document.body.classList.add('size-guide-open');
    document.addEventListener('keydown', this.onKeyDown);
    this.setAttribute('aria-hidden', 'false');

    const focusTarget =
      this.querySelector('.size-guide-modal__close') || this.dialog;
    if (focusTarget) focusTarget.focus();
  }

  close() {
    if (!this.classList.contains('is-open')) return;

    this.classList.remove('is-open');
    document.body.classList.remove('size-guide-open');
    document.removeEventListener('keydown', this.onKeyDown);
    this.setAttribute('aria-hidden', 'true');

    if (this.trigger && typeof this.trigger.focus === 'function') {
      this.trigger.focus();
    }
  }
}

if (!customElements.get('size-guide-modal')) {
  customElements.define('size-guide-modal', SizeGuideModal);
}
